/**
 * Created by Karol Kluska on 06.09.17.
 */
angular
    .module('app')
    .directive('loader', function ($rootScope, $interval) {
      return {
        restrict: 'E',
        templateUrl: 'app/shared/loader/loader.html',
        link: link
      };

      function link(scope, element) {
        element
            .hide()
            .css({
              position: 'absolute',
              'z-index': '99999'
            });
        var stopAddDots;
        var header = element.find('h2');
        var description = element.find('p');

        var destroyStart = $rootScope.$on('startLoading', startLoading);
        var destroyStop = $rootScope.$on('stopLoading', stopLoading);

        $rootScope.$on('$destroy', destroyStart);
        $rootScope.$on('$destroy', destroyStop);

        var i = 0;
        function startLoading(event, data) {
          if (!event.defaultPrevented) {
            event.defaultPrevented = true;

            element.fadeIn(250);
            header.text(data.title);
            description.text(data.description);
            stopAddDots = $interval(function () {
              i = ++i % 4;
              description.text(data.description + new Array(i + 1).join('.'));
            }, 500);
          }
        }

        function stopLoading() {
          element.fadeOut(250, cleanText());
        }

        function cleanText() {
          if (angular.isDefined(stopAddDots)) {
            $interval.cancel(stopAddDots);
          }
          header.text('');
          description.text('');
        }
      }
    });
